export default {"src":"/_next/static/media/fingerprint.aa228bf5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};